var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGeraldine2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 232 353",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fcdbbc;\n      }\n\n      .cls-2 {\n        fill: #825c41;\n      }\n\n      .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8 {\n        fill: none;\n      }\n\n      .cls-3, .cls-5, .cls-6 {\n        stroke-width: 3px;\n      }\n\n      .cls-3, .cls-5, .cls-6, .cls-7 {\n        stroke-linecap: round;\n      }\n\n      .cls-3, .cls-5, .cls-7 {\n        stroke-linejoin: round;\n      }\n\n      .cls-3, .cls-6 {\n        stroke: #000;\n      }\n\n      .cls-4 {\n        stroke: #42c763;\n        stroke-width: 2px;\n      }\n\n      .cls-4, .cls-6, .cls-8 {\n        stroke-miterlimit: 10;\n      }\n\n      .cls-9 {\n        fill: #015e59;\n      }\n\n      .cls-10 {\n        fill: #faf9f8;\n      }\n\n      .cls-11 {\n        fill: #f8d9bc;\n      }\n\n      .cls-12 {\n        fill: #414a4c;\n      }\n\n      .cls-13 {\n        fill: #66452e;\n      }\n\n      .cls-14 {\n        fill: #7150b3;\n      }\n\n      .cls-15 {\n        fill: #eeb68c;\n      }\n\n      .cls-16 {\n        fill: #b7c8d8;\n      }\n\n      .cls-17 {\n        fill: #063842;\n      }\n\n      .cls-18 {\n        clip-path: url(#clippath-1);\n      }\n\n      .cls-19 {\n        clip-path: url(#clippath-2);\n      }\n\n      .cls-20 {\n        fill: #e6eef2;\n      }\n\n      .cls-21 {\n        fill: #fff;\n      }\n\n      .cls-22 {\n        fill: #42c763;\n      }\n\n      .cls-23 {\n        fill: #b192f3;\n      }\n\n      .cls-5, .cls-7 {\n        stroke: #eeb68c;\n      }\n\n      .cls-24 {\n        fill: #0d5359;\n      }\n\n      .cls-25 {\n        fill: #63e06b;\n      }\n\n      .cls-26 {\n        fill: #8ff584;\n      }\n\n      .cls-7 {\n        stroke-width: 2.32px;\n      }\n\n      .cls-27 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-8 {\n        stroke: #906ed9;\n        stroke-width: 7px;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M82.64,148.31h20.26c9.59,0,17.37,7.78,17.37,17.37v7.37c0,3.49-2.83,6.32-6.32,6.32h-42.37c-3.49,0-6.32-2.83-6.32-6.32v-7.37c0-9.59,7.78-17.37,17.37-17.37Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 84.39,
    y: 89.56,
    width: 22.72,
    height: 31.83,
    rx: 11.36,
    ry: 11.36
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 121.36,
    y: 89.56,
    width: 22.72,
    height: 31.83,
    rx: 11.36,
    ry: 11.36
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Calque_3"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 100,
    cy: 309,
    rx: 68,
    ry: 28
  })), /*#__PURE__*/React.createElement("g", {
    id: "Calque_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 113.59,
    y: 140.93,
    width: 17.33,
    height: 53.28,
    rx: 8.66,
    ry: 8.66,
    transform: "translate(327.2 199.62) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 144.29,
    y: 153.65,
    width: 17.33,
    height: 53.28,
    rx: 8.66,
    ry: 8.66,
    transform: "translate(333.25 27.34) rotate(90)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 171.58,
    cy: 174.61,
    r: 14.34
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 92.77,
    y: 198.26,
    width: 22.17,
    height: 65.8,
    rx: 11.09,
    ry: 11.09,
    transform: "translate(207.72 462.32) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M114.95,288.35v-35.35c0-6.12-4.96-11.09-11.09-11.09s-11.09,4.96-11.09,11.09v33.68l22.17,1.67Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 92.77,
    y: 282.55,
    width: 22.17,
    height: 13.32,
    transform: "translate(207.72 578.42) rotate(-180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M97.79,294.59h33.28v13.13h-30.18c-4.48,0-8.11-3.63-8.11-8.11h0c0-2.77,2.25-5.02,5.02-5.02Z",
    transform: "translate(223.84 602.3) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M92.77,186.54h30.4v43.62h-16.02c-7.93,0-14.38-6.44-14.38-14.38v-29.25h0Z",
    transform: "translate(215.95 416.7) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 92.77,
    y: 220.89,
    width: 32.77,
    height: 9.28,
    transform: "translate(218.32 451.05) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 72.38,
    y: 175.82,
    width: 40.79,
    height: 21.45
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 72.38,
    y: 177.92,
    width: 40.79,
    height: 6.84
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M92.77,15.55h0c-26.27,0-49.23,17.73-55.88,43.14l-15.22,58.2c-4.16,15.89,7.84,31.43,24.26,31.43h33.52c46.85,0,81.05-44.29,69.2-89.62h0c-6.65-25.42-29.61-43.14-55.88-43.14Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M82.64,148.31h20.26c9.59,0,17.37,7.78,17.37,17.37v7.37c0,3.49-2.83,6.32-6.32,6.32h-42.37c-3.49,0-6.32-2.83-6.32-6.32v-7.37c0-9.59,7.78-17.37,17.37-17.37Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-27"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M76.72,146.87h32.11v.07c0,6.28-5.1,11.38-11.38,11.38h-9.34c-6.28,0-11.38-5.1-11.38-11.38v-.07h0Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M73.32,69.16h71.99v40.39c0,21.39-17.37,38.76-38.76,38.76h-18.94c-13.06,0-23.66-10.6-23.66-23.66v-46.12c0-5.17,4.2-9.37,9.37-9.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M92.09,51.6h25.08c15.53,0,28.14,12.61,28.14,28.14v35.44c0,18.07-14.67,32.74-32.74,32.74h-15.88c-18.07,0-32.74-14.67-32.74-32.74v-35.44c0-15.53,12.61-28.14,28.14-28.14Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 80.74,
    y: 133.33,
    width: 24.07,
    height: 17.32
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M95.37,42.98h17.74c21.35,0,38.68,17.33,38.68,38.68v1.28h-32.91c-12.98,0-23.51-10.53-23.51-23.51v-16.45h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M72.38,189.24h40.79v8.88c0,7.41-6.01,13.42-13.42,13.42h-13.95c-7.41,0-13.42-6.01-13.42-13.42v-8.88h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M119.37,139.97c-7.78,2.53-16.13-1.72-18.67-9.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M115.86,109.4l5.97,16.86c.51,1.44-.56,2.96-2.09,2.96h-2.66c-1.65,0-2.99-1.34-2.99-2.99v-16.52c0-1.02,1.43-1.27,1.77-.3Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 75.47,
    y: 189.24,
    width: 2.7,
    height: 5.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 81.85,
    y: 189.24,
    width: 2.7,
    height: 5.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 88.23,
    y: 189.24,
    width: 2.7,
    height: 5.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 94.62,
    y: 189.24,
    width: 2.7,
    height: 5.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 101,
    y: 189.24,
    width: 2.7,
    height: 5.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 107.38,
    y: 189.24,
    width: 2.7,
    height: 5.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 71.79,
    y: 209.57,
    width: 22.17,
    height: 65.8,
    rx: 11.09,
    ry: 11.09
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M93.96,302.16v-37.85c0-6.12-4.96-11.09-11.09-11.09h0c-6.12,0-11.09,4.96-11.09,11.09v35.27l22.17,2.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M76.75,195.16h23.84v43.62h-38.21v-29.25c0-7.93,6.44-14.38,14.38-14.38Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 60.01,
    y: 229.5,
    width: 43.85,
    height: 9.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 71.79,
    y: 293.85,
    width: 22.17,
    height: 13.32
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M76.8,305.89h33.28v13.13h-30.18c-4.48,0-8.11-3.63-8.11-8.11h0c0-2.77,2.25-5.02,5.02-5.02Z",
    transform: "translate(181.87 624.91) rotate(-180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M105.46,199.3h5.03v9.01c0,2.78-2.26,5.03-5.03,5.03h0v-14.05h0Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 93.74,
    y1: 240.27,
    x2: 93.74,
    y2: 291.73
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 84.39,
    y: 89.56,
    width: 22.72,
    height: 31.83,
    rx: 11.36,
    ry: 11.36
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 91.83,
    y: 98.68,
    width: 12.63,
    height: 21.18,
    rx: 6.31,
    ry: 6.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 90.86,
    y: 95.34,
    width: 6.91,
    height: 12.59,
    rx: 3.45,
    ry: 3.45
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M84.39,101.12v-.2c0-6.27,5.09-11.36,11.36-11.36h0c6.27,0,11.36,5.09,11.36,11.36v.2"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 80.6,
    y1: 97.18,
    x2: 84.63,
    y2: 98.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 82.13,
    y1: 92.86,
    x2: 85.9,
    y2: 94.87
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 121.36,
    y: 89.56,
    width: 22.72,
    height: 31.83,
    rx: 11.36,
    ry: 11.36
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 128.8,
    y: 98.68,
    width: 12.63,
    height: 21.18,
    rx: 6.31,
    ry: 6.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 127.83,
    y: 95.34,
    width: 6.91,
    height: 12.59,
    rx: 3.45,
    ry: 3.45
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M121.36,101.12v-.2c0-6.27,5.09-11.36,11.36-11.36h0c6.27,0,11.36,5.09,11.36,11.36v.2"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 148.04,
    y1: 97.18,
    x2: 144,
    y2: 98.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 146.5,
    y1: 92.86,
    x2: 142.73,
    y2: 94.87
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M83.11,113.73h0c6.39,0,11.57,5.19,11.57,11.57v2.04h-10.13c-3.24,0-5.87-2.63-5.87-5.87v-3.32c0-2.44,1.98-4.43,4.43-4.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M136.79,113.73h9.23v5.54c0,4.46-3.62,8.08-8.08,8.08h0c-3.2,0-5.8-2.6-5.8-5.8v-3.16c0-2.57,2.09-4.65,4.65-4.65Z",
    transform: "translate(278.16 241.08) rotate(-180)"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "100.59 229.5 100.59 216.18 105.46 216.18"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M215.24,131.32l-11,46.86-52.46,14.65c-4.12,1.15-7.97-2.54-6.99-6.7l8.83-37.6,61.63-17.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M210.44,134.96l-9.29,39.66-61.85,17.27,8.03-34.27c.78-3.32,3.31-5.96,6.59-6.88l56.52-15.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M171.62,165.43l-57.66,16.1,3.03-6.01c1.41-2.79,3.89-4.84,6.87-5.67l45.45-12.69,2.31,8.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M210.44,134.96l-8.94,38.22-2.43-3.01c-1.93-2.4-2.65-5.55-1.95-8.55l4.48-19.16c.78-3.32,3.31-5.96,6.59-6.88l2.25-.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M163.44,160.71l39.48,14.32-4.14-5.79c-1.7-2.38-4.07-4.19-6.8-5.22l-17.4-6.53c-3.2-1.19-6.79-.54-9.38,1.69l-1.77,1.53Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "101.63 183.32 149.98 193.05 205.47 180.59 164.73 164.93 101.63 183.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M218.65,132.17l-9.95,41.23c-.71,2.94-3.79,4.63-6.65,3.65l-40.81-14.65-60.5,17.57"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 76.08,
    y: 157.42,
    width: 17.33,
    height: 53.28,
    rx: 8.66,
    ry: 8.66,
    transform: "translate(-105.33 113.83) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 107.17,
    y: 170.31,
    width: 17.33,
    height: 53.28,
    rx: 8.66,
    ry: 8.66,
    transform: "translate(-81.11 312.78) rotate(-90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M134.46,176.92c7.92,0,14.34,6.42,14.34,14.34s-6.42,14.34-14.34,14.34c-7.92,0-14.34-6.42-14.34-14.34s6.42-14.34,14.34-14.34Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeraldine2);
export default __webpack_public_path__ + "static/media/geraldine_2.45775598c6bdef0b442c275bea6b3ed4.svg";
export { ForwardRef as ReactComponent };